import { fg } from '@atlaskit/platform-feature-flags';

export const getConfluencePageSearchURL = ({
	cqlQuery,
	cloudId,
	gatewayBaseUrl = '',
}: {
	cqlQuery: string;
	cloudId: string;
	gatewayBaseUrl: string;
}) =>
	`${gatewayBaseUrl}/gateway/api/ex/confluence/${cloudId}/wiki/rest/api/content/search?${new URLSearchParams(
		{
			cql: cqlQuery,
			expand: fg('live_docs_button_issue_view_improvements')
				? 'space.typeSettings,link'
				: 'space,link',
		},
	).toString()}`;
